(function(){
    angular
        .module('appback')
        .directive('ngEstadisticas', estadisticasHoja);
        estadisticasHoja.$inject = ['HojaService','StockService','$timeout', 'Upload'];
        function estadisticasHoja(HojaService,StockService,$timeout, Upload){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/hojafabricacion/template?name=estadisticas.twig',
		        scope: {
                    hc:'=',
                },
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        scope.estadisticas = {};
                        scope.getEstadisticas = function(){
                            HojaService.getEstadisticas(scope.hc.idhojafabricacionactiva, function(data){
                                console.log(data);
                                scope.estadisticas = data;
                            });
                        }
                        scope.getEstadisticas();

			        });
		        }
          }
      }
})();